import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container, NavDropdown, Image } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import './Header.css';
import { authService } from '../services/api';
import { config } from '../services/api';
import axios from 'axios';

function Header() {
  const [isAuthenticated, setIsAuthenticated] = useState(authService.isAuthenticated());
  const [userRole, setUserRole] = useState(authService.getUserRole() || 'visitor');
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();

  // Listen for authentication changes
  useEffect(() => {
    // Function to check auth status
    const checkAuthStatus = async () => {
      const token = localStorage.getItem('token');
      
      if (token) {
        try {
          // Fetch user data from API
          const response = await axios.get(`${config.API_URL}/api/users/me/`, {
            headers: { 'Authorization': `Bearer ${token}` }
          });
          
          setUserData(response.data);
          setIsAuthenticated(true);
          setUserRole(response.data.role || 'visitor');
          
          // Store role in localStorage for authService to use
          localStorage.setItem('user_role', response.data.role);
        } catch (error) {
          console.error('Error fetching user data:', error);
          // Handle authentication error
          authService.logout();
          setIsAuthenticated(false);
          setUserRole('visitor');
          setUserData(null);
        }
      } else {
        setIsAuthenticated(false);
        setUserRole('visitor');
        setUserData(null);
      }
    };

    // Check initially
    checkAuthStatus();

    // Set up event listener for storage changes (logout/login from other tabs)
    window.addEventListener('storage', checkAuthStatus);
    
    // Custom event for auth changes within the same tab
    window.addEventListener('authChange', checkAuthStatus);

    return () => {
      window.removeEventListener('storage', checkAuthStatus);
      window.removeEventListener('authChange', checkAuthStatus);
    };
  }, []);

  const handleLogout = () => {
    authService.logout();
    
    // Dispatch custom event to notify about auth change
    window.dispatchEvent(new Event('authChange'));
    
    navigate('/');
  };

  // Get user initials for avatar placeholder
  const getUserInitials = () => {
    if (!userData) return 'U';
    
    // Use email first letter if available
    if (userData.email) {
      return userData.email.charAt(0).toUpperCase();
    }
    
    // Fallback to username or first_name
    const displayName = userData.username || userData.first_name || 'U';
    return displayName.charAt(0).toUpperCase();
  };

  // Get avatar image or placeholder
  const getAvatarDisplay = () => {
    if (userData && userData.avatar) {
      return <Image src={userData.avatar} roundedCircle className="user-avatar" />;
    }
    
    return (
      <div className="avatar-placeholder">
        {getUserInitials()}
      </div>
    );
  };

  return (
    <Navbar className="navbar-warm fixed-top" expand="lg">
      <Container>
        <Navbar.Brand as={Link} to="/">
          <img src={`${config.MEDIA_URL}/logos/logo.png`} alt="Delta X Logo" className="img-fluid" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarNav">
          <span className="toggle-icon"></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="navbarNav">
          <Nav className="ms-auto">
            <Nav.Item className="active">
              <Nav.Link as={Link} to="/">
                <i className="fas fa-home"></i> Accueil
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/about">
                <i className="fas fa-info-circle"></i> DELTA X
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/Evenements">
                <i className="fas fa-calendar-alt"></i> Evenements
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/contact">
                <i className="fas fa-envelope"></i> Contactez-nous
              </Nav.Link>
            </Nav.Item>
            
            {isAuthenticated ? (
              <NavDropdown 
                title={getAvatarDisplay()} 
                id="user-dropdown"
                align="end"
                className="profile-dropdown"
              >
                <NavDropdown.Item as={Link} to="/profile">
                  <i className="fas fa-user me-2"></i> Mon profil
                </NavDropdown.Item>
                
                {userRole === 'visitor' && (
                  <NavDropdown.Item as={Link} to="/my-reservations">
                    <i className="fas fa-ticket-alt me-2"></i> Mes réservations
                  </NavDropdown.Item>
                )}
                {console.log(userRole)}
                {userRole === 'partner_admin' && (
                  <>
                    <NavDropdown.Item as={Link} to="/my-reservations">
                      <i className="fas fa-ticket-alt me-2"></i> Mes réservations
                    </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/cpanel">
                      <i className="fas fa-cogs me-2"></i> Cpanel
                    </NavDropdown.Item>
                  </>
                )}
                
                {(userRole === 'superuser' || userRole === 'delta_admin' ) && (
                  <NavDropdown.Item as={Link} to="/admin/dashboard">
                    <i className="fas fa-shield-alt me-2"></i> Administration
                  </NavDropdown.Item>
                )}
                
                <NavDropdown.Divider />
                
                <NavDropdown.Item onClick={handleLogout}>
                  <i className="fas fa-sign-out-alt me-2"></i> Se déconnecter
                </NavDropdown.Item>
              </NavDropdown>
            ) : (
              <Nav.Item>
                <Nav.Link as={Link} to="/login" className="login-link">
                  <i className="fas fa-sign-in-alt"></i> Se connecter
                </Nav.Link>
              </Nav.Item>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;